<micro-select-combo #sel
              placeholder="Message Type"
              [mode]="mode"
              [(id)]="messageType"
              (idChange)="change($event)"
              [required]="required"
              [options]="options"
              [disabled]="disabled"
>
</micro-select-combo>
